import { render, staticRenderFns } from "./EditorCell.vue?vue&type=template&id=1f38e6db&scoped=true&"
import script from "./EditorCell.vue?vue&type=script&lang=js&"
export * from "./EditorCell.vue?vue&type=script&lang=js&"
import style0 from "./EditorCell.vue?vue&type=style&index=0&id=1f38e6db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f38e6db",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VListItem,VListItemContent,VListItemTitle,VSelect,VTextField})
